import {
  myTenantList,
  login,
  loginB2BSSO,
  loginZSTSSO,
  logout,
  tenantAuthorization,
  tbrLoginZSTSSO,
  querySpeedB2BLinkUrl
} from "@root/graphql/Login.gql";
import {
  K1_PCR_apolloClient,
  K1_TBR_apolloClient,
  K1_YGJ_apolloClient
} from "@root/lib/allApolloClient";
export default {
  namespaced: true,
  state: {
    tenanList: []
  },
  actions: {
    async loginB2BSSO({ rootState, dispacth }: any, params?: any) {
      return await rootState.gql.query({
        query: loginB2BSSO,
        variables: params
      });
    },
    async loginZSTSSO({ rootState, dispacth }: any, params?: any) {
      return await rootState.gql.query({
        query: loginZSTSSO,
        variables: params
      });
    },
    async tbrLoginZSTSSO({ rootState, dispacth }: any, params?: any) {
      return await K1_TBR_apolloClient.query({
        query: tbrLoginZSTSSO,
        variables: params
      });
    },

    async tbrLoginQipei({ rootState, dispacth }: any, params?: any) {
      let { data = {} }: any = await K1_YGJ_apolloClient.query({
        query: querySpeedB2BLinkUrl,
        variables: params
      });
      console.log(data, "00989");
      return data ? data.api.authLink : "";
    },
    async login({ rootState, dispacth }: any, data?: any) {
      let {
        data: {
          login: { optionalTenants, ...other }
        }
      } = await rootState.gql.query({
        query: login,
        variables: { identity: { ...data, tenantCode: "100007" } }
      });
      //
      const userInfos = { ...other };
      let { userAuthToken } = userInfos;
      localStorage.setItem("AuthToken", userAuthToken);
      localStorage.setItem("userInfo", JSON.stringify(userInfos));
      localStorage.setItem("org", "default");
    },
    async logout({ rootState }: any) {
      await rootState.gql.query({ query: logout });
      localStorage.clear();
    },
    async getTenanList({ rootState, commit }: any, data?: any) {
      let res = await rootState.gql.query({ query: myTenantList });
      commit("setTenantList", res.data.queryMyTenantList);
    },
    async tenantAuthorization({ rootState }, data) {
      let res = await rootState.gql.query({
        query: tenantAuthorization,
        variables: data
      });
    }
  },
  mutations: {
    setTenantList(state, data) {
      state.tenanList = data;
    }
  }
};
